module.exports = __webpack_public_path__ + "static/media/LoginBarFingerPrint.8f6725d8.svg";